import { render, staticRenderFns } from "./Worklists.vue?vue&type=template&id=31ddce5d&scoped=true&"
import script from "./Worklists.vue?vue&type=script&lang=js&"
export * from "./Worklists.vue?vue&type=script&lang=js&"
import style0 from "./Worklists.vue?vue&type=style&index=0&id=31ddce5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ddce5d",
  null
  
)

export default component.exports